
import "../../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_Ticker";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_Ticker__root","up":"wds_1_223_0_Ticker__up","down":"wds_1_223_0_Ticker__down"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-text-disabled":"--wds-color-text-disabled","wds-color-text-primary":"--wds-color-text-primary","wds-space-100":"--wds-space-100"}; 




